const CALLBACK_DELAY = 120000; // 1min
const DEFAULT_MONEY = 'N/A';
const SESSION_STORAGE = {
  MODULE_ID: 'B2B_AEH_UPGRADE_ORDER',
  PNQ_AUTH_TOKEN: 'PNQ_AUTH_TOKEN',
  KYC_AUTH_TOKEN: 'KYC_AUTH_TOKEN',
  USER_TYPE: 'USER_TYPE',
  LEAD_ID: 'LEAD_ID',
  ORDER_ID: 'ORDER_ID',
  // ORDER_DETAILS: 'ORDER_DETAILS',
  LSI_ID: 'LSI_ID',
  PARTY_ID: 'PARTY_ID',
  SITE_IN_CHARGE: 'SITE_IN_CHARGE'
};

const PRODUCT_NAME = {
  INTERNET: 'Dedicated Internet (ILL)',
  MPLS: 'VPN (MPLS)'
};

const LOB_PRODUCT_NAME = {
  INTERNET: 'Dedicated Internet',
  MPLS: 'VPN',
  DEDICATED_INTERNET: 'Dedicated Internet'
};

const TOAST_TYPE = {
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  ORDER_CONFIRMATION: 'order_confirmation'
};

const USER_TYPE = {
  CUSTOMER: 'CUSTOMER',
  KAM: 'KAM'
};

const HARDWARE_TYPE = {
  STANDARD: 'Standard',
  NON_STANDARD: 'Non-Standard'
};

const SERVICE_TYPE = {
  MANAGED: 'MANAGED',
  UNMANAGED: 'UNMANAGED',
  PARTIALLY_MANAGED: 'PARTIALLY_MANAGED'
};

const CUSTOMER_ROLE = {
  AUTHORIZED_SIGNATORY: 'Authorized Signatory'
};

const ACTIVE_TABS = {
  STANDARD_PRICE: 'STANDARD_PRICE',
  CUSTOM_PRICE: 'CUSTOM_PRICE'
};

const LEAD_STATUS = {
  LEAD_IN_PROGRESS: 'LEAD_IN_PROGRESS',
  FEASIBILITY_PENDING: 'FEASIBILITY_PENDING',
  FEASIBILITY_COMPLETED: 'FEASIBILITY_COMPLETED',
  LOCATION_NOT_FEASIBLE: 'LOCATION_NOT_FEASIBILE',
  LEAD_SUBMITTED: 'LEAD_SUBMITTED',
  LEAD_CANCELLED: 'LEAD_CANCELLED',
  REQUIRED_PRICE_NEGOTIATION: 'REQUIRED_PRICE_NEGOTIATION',
  PRICING_APPROVAL_REQUEST_SENT: 'PRICING_APPROVAL_REQUEST_SENT',
  PRICING_DOA_APPROVED: 'PRICING_DOA_APPROVED',
  PRICING_DOA_REJECTED: 'PRICING_DOA_REJECTED',
  KYC_IN_PROGRESS: 'KYC_IN_PROGRESS',
  ORDER_CANCELLED: 'ORDER_CANCELLED',
  KYC_SUBMITTED: 'KYC_SUBMITTED',
  PENDING: 'PENDING'
};

const ORDER_STATUS = {
  OV_REJECTED: 'OV_REJECTED',
  ORDER_SUBMITTED: 'ORDER_SUBMITTED'
};

const MEDIA_TYPES = {
  WIRELINE: 'WIRELINE',
  OFFNET: 'Offnet',
  WIRELESS: 'WIRELESS',
  THIRD_PARTY: 'Third Party'
};

const DOA_STATUS = {
  IN_PROGRESS: 'IN_PROGRESS',
  CLARITY_REQUIRED: 'CLARITY_REQUIRED',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  AUTO_APPROVED: 'AUTO_APPROVED',
  PUSHED_LEAD_TO_KYC: 'PUSHED_LEAD_TO_KYC'
};

const KAM_MESSAGE_STATUS = {
  DOA_CLARITY_REQUEST: 'DOA has requested for clarity on the customised price submitted.',
  KAM_SUBMIT_CLARITY: 'Clarity on customised pricing is submitted.',
  DOA_APPROVED_PRICING: 'Customised pricing is approved by the DOA and is notified to the customer automatically.',
  DOA_REJECTED_PRICING: 'Customised pricing is rejected by the DOA.',
  CUSTOMIZED_PRICING: 'Customer has requested for customized pricing.',
  LEAD_SUBMITTED: 'Approved and will be notified to the customer automatically.',
  DOA_PRICING_REQUEST: 'Customised price is submitted for DOA approval.',
  LOWER_BW_PRICING: 'The Annual Recurring Cost for the upgraded bandwidth is less than the current running Annual Recurring Cost. Please review the pricing.'
};

const DOCUMENT_TYPE_ENUM = {
  SEZ: 'SEZ',
  PURCHASE_ORDER: 'PURCHASE_ORDER',
  AUTHORIZED_SIGNATORY: 'AUTHORIZED_SIGNATORY'
};

const FIELD_ERROR = {
  REQUIRED: 'This is a mandatory field',
  ARC_ERR_MSG: 'Recurring charge cannot be zero',
  LOW_PRICE_MSG: 'Rental should be greater than existing plan price',
  INVALID_NO: 'Please enter valid 10 digit mobile number'
};

const CONTRACT_PERIOD_LIST = [
  {
    key: 1,
    displayName: '1 year'
  },
  {
    key: 2,
    displayName: '2 years'
  },
  {
    key: 3,
    displayName: '3 years'
  },
  {
    key: 4,
    displayName: '4 years'
  },
  {
    key: 5,
    displayName: '5 years'
  }
];

const PRICE_TYPE_ENUM = {
  RATE: 'RATE',
  FLOOR_RATE: 'FLOOR_RATE'
};

const PRICE_TYPES = [
  {
    key: PRICE_TYPE_ENUM.RATE,
    displayName: 'Standard Rate Price'
  },
  {
    key: PRICE_TYPE_ENUM.FLOOR_RATE,
    displayName: 'Floor Rate Price'
  }
];

const NOTIFICATION_ACTION = {
  EDIT_WITH_EXCEL: 'editWithExcel',
  PROCEED: 'proceed',
  DOWNLOAD_EXCEL: 'downloadExcel',
  VIEW_MORE: 'viewMore',
  ORDER_CONFIRMATION: 'orderConfirmation'
};

const NOTIFICATION_MESSAGE = {
  ORDER_REJECTED: 'Your order has been rejected',
  ORDER_REJECTED_BEACUSE: `Kindly resubmit the order after updating the details. Following are the reason(s) for rejection : `
};

const ORDER_REMARK = {
  REMARK_1: 'POI/POA Blur or Unclear.',
  REMARK_2: `User should be able to scroll down and edit the PO section and resubmit the same order. The existing PO details like the PO number, PO date and PO attachment will be shown by default.`
};

export {
  SESSION_STORAGE,
  USER_TYPE,
  PRODUCT_NAME,
  TOAST_TYPE,
  LEAD_STATUS,
  DOA_STATUS,
  DOCUMENT_TYPE_ENUM,
  HARDWARE_TYPE,
  CUSTOMER_ROLE,
  SERVICE_TYPE,
  FIELD_ERROR,
  ACTIVE_TABS,
  KAM_MESSAGE_STATUS,
  CALLBACK_DELAY,
  CONTRACT_PERIOD_LIST,
  PRICE_TYPE_ENUM,
  PRICE_TYPES,
  DEFAULT_MONEY,
  MEDIA_TYPES,
  LOB_PRODUCT_NAME,
  NOTIFICATION_ACTION,
  NOTIFICATION_MESSAGE,
  ORDER_STATUS,
  ORDER_REMARK
};
